export default "__VITE_ASSET__C0kg$kx5__"